<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li v-for="(item, index) in partnerGoodsInfo.partners" :key="index"
              @click="swatchPartner(item)"
              :class="{ 'selected': partnerGoodsInfo.conditions.ppId == item.ppId }">
              {{ item.partnerName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('partnerGoods.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input :placeholder="$t('partnerGoods.placeholder.productId')"
                v-model="partnerGoodsInfo.conditions.valueId" style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('partnerGoods.placeholder.productName')"
                v-model="partnerGoodsInfo.conditions.prodName" style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('partnerGoods.placeholder.productDesc')"
                v-model="partnerGoodsInfo.conditions.prodDesc" style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('partnerGoods.placeholder.state')"
                v-model="partnerGoodsInfo.conditions.state" style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryPartnerGoodsMethod()">
                <i class="el-icon-search"></i>
                {{ $t('partnerGoods.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('partnerGoods.partnerGoods') }}</span>
            <div>
              <el-button type="primary" size="small"
                @click="_toSendGoodsStockToPartner()">{{ $t('partnerGoods.syncStock') }}</el-button>
              <el-button type="primary" size="small"
                @click="_toSendGoodsPriceToPartner()">{{ $t('partnerGoods.syncPrice') }}</el-button>
              <el-button type="primary" size="small"
                @click="_toSendGoodsToPartner()">{{ $t('partnerGoods.syncGoods') }}</el-button>
            </div>
          </div>
          <el-table :data="partnerGoodsInfo.partnerGoodss" border style="width: 100%" v-loading="loading">
            <el-table-column prop="productId" :label="$t('partnerGoods.productId')" align="center" />
            <el-table-column prop="prodName" :label="$t('partnerGoods.productName')" align="center" />
            <el-table-column prop="prodDesc" :label="$t('partnerGoods.productDesc')" align="center" />
            <el-table-column prop="valueId" :label="$t('partnerGoods.specId')" align="center" />
            <el-table-column prop="outValueId" :label="$t('partnerGoods.externalCode')" align="center">
              <template #default="{row}">
                {{ row.outValueId || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="state" :label="$t('partnerGoods.state')" align="center">
              <template #default="{row}">
                {{ row.state == 'Y' ? $t('partnerGoods.syncSuccess') : $t('partnerGoods.syncFailed') }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" :label="$t('partnerGoods.syncRemark')" align="center">
              <template #default="{row}">
                {{ row.remark || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('partnerGoods.syncTime')" align="center" />
            <el-table-column :label="$t('partnerGoods.operation')" align="center">
              <template #default="{row}">
                <el-button type="text" size="small"
                  @click="_openDeletePartnerGoodsModel(row)">{{ $t('partnerGoods.delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="partnerGoodsInfo.conditions.page"
            :page-size="partnerGoodsInfo.conditions.row" layout="total, prev, pager, next"
            :total="partnerGoodsInfo.total" style="margin-top: 20px; text-align: right;" />
        </el-card>
      </el-col>
    </el-row>

    <delete-partner-goods ref="deletePartnerGoods" @refresh="_queryPartnerGoodsMethod"></delete-partner-goods>
    <sync-partner-goods-price ref="syncPartnerGoodsPrice" @refresh="_queryPartnerGoodsMethod"></sync-partner-goods-price>
    <sync-partner-goods-stock ref="syncPartnerGoodsStock" @refresh="_queryPartnerGoodsMethod"></sync-partner-goods-stock>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import {
  listPartnerGoods,
  listPartnerPool
} from '@/api/partner/partnerGoodsApi'

export default {
  name: 'PartnerGoods',
  components: {
    'delete-partner-goods': () => import('@/components/partner/deletePartnerGoods/deletePartnerGoods.vue'),
    'sync-partner-goods-price': () => import('@/components/partner/syncPartnerGoodsPrice/syncPartnerGoodsPrice.vue'),
    'sync-partner-goods-stock': () => import('@/components/partner/syncPartnerGoodsStock/syncPartnerGoodsStock.vue')
  },
  data() {
    return {
      loading: false,
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      partnerGoodsInfo: {
        partnerGoodss: [],
        partners: [],
        total: 0,
        records: 1,
        moreCondition: false,
        pgId: '',
        conditions: {
          ppId: '',
          valueId: '',
          prodName: '',
          prodDesc: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this.partnerGoodsInfo.conditions.shopId = getShopId()
    this._listPartners()
  },
  methods: {
    handleCurrentChange(val) {
      this._listPartnerGoodss(val, this.DEFAULT_ROWS)
    },
    _listPartnerGoodss(page, rows) {
      this.loading = true
      this.partnerGoodsInfo.conditions.page = page
      this.partnerGoodsInfo.conditions.row = rows
      listPartnerGoods(this.partnerGoodsInfo.conditions)
        .then(res => {
          this.partnerGoodsInfo.total = res.total
          this.partnerGoodsInfo.records = res.records
          this.partnerGoodsInfo.partnerGoodss = res.data
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    _toSendGoodsToPartner() {
      const ppId = this.partnerGoodsInfo.conditions.ppId
      if (!ppId) {
        this.$message.warning(this.$t('partnerGoods.selectPartner'))
        return
      }
      this.$router.push(`/pages/partner/transferPartnerGoods?ppId=${ppId}`)
    },
    _toSendGoodsPriceToPartner() {
      const ppId = this.partnerGoodsInfo.conditions.ppId
      if (!ppId) {
        this.$message.warning(this.$t('partnerGoods.selectPartner'))
        return
      }
      this.$refs.syncPartnerGoodsPrice.open({ ppId })
    },
    _toSendGoodsStockToPartner() {
      const ppId = this.partnerGoodsInfo.conditions.ppId
      if (!ppId) {
        this.$message.warning(this.$t('partnerGoods.selectPartner'))
        return
      }
      this.$refs.syncPartnerGoodsStock.open({ ppId })
    },
    _openDeletePartnerGoodsModel(partnerGoods) {
      this.$refs.deletePartnerGoods.open(partnerGoods)
    },
    _queryPartnerGoodsMethod() {
      this._listPartnerGoodss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _moreCondition() {
      console.log(this.partnerGoodsInfo.moreCondition)
      this.partnerGoodsInfo.moreCondition = !this.partnerGoodsInfo.moreCondition
    },
    _listPartners() {
      const params = {
        page: 1,
        row: 100,
        shopId: getShopId()
      }
      listPartnerPool(params)
        .then(res => {
          this.partnerGoodsInfo.partners = res.data
          if (res.data && res.data.length > 0) {
            this.partnerGoodsInfo.conditions.ppId = res.data[0].ppId
            this._listPartnerGoodss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
          }
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
    },
    swatchPartner(item) {
      this.partnerGoodsInfo.conditions.ppId = item.ppId
      this._listPartnerGoodss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>